/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_TitleInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft and Excel: Open, Edit and Save XLSX Files`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 与 Excel：打开、编辑和保存 XLSX 文件`)
};

/**
* | output |
* | --- |
* | "GridCraft and Excel: Open, Edit and Save XLSX Files" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_title(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_title(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_title as "gc.search_guides.gridcraft_excel_compatibility.title" }